'use client';

import { useCallback } from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- shared package uses untyped hooks
import { useDispatch } from 'react-redux';
import logExploreTrailCardListActionTaken from '@alltrails/amplitude/events/logExploreTrailCardListActionTaken';
import { updateExploreActionType, updateSeasonalMonth } from '../../redux/exploreServiceSlice';
import type { SeasonalMonth } from '../../utils/seasonalMonth';
import SeasonalMonthSelector from '../SeasonalMonthSelector/SeasonalMonthSelector';

type ExploreSeasonalMonthSelectorProps = {
  selectedMonth: SeasonalMonth;
  testId?: string;
};

/**
 * Wrapper component for SeasonalMonthSelector that handles the common Redux actions
 * and analytics logging for updating seasonal month state. This component is used across
 * different sidebars (ExploreRootSidebar, ExploreParkSidebar, ExplorePOISidebar) and
 * the AllFiltersModal.
 *
 * @param selectedMonth - The currently selected seasonal month
 * @param testId - Optional test ID for the underlying selector
 */
const ExploreSeasonalMonthSelector = ({ selectedMonth, testId }: ExploreSeasonalMonthSelectorProps) => {
  const dispatch = useDispatch();

  const handleSeasonalMonthChange = useCallback(
    (month: SeasonalMonth) => {
      console.log('month', month);
      dispatch(updateSeasonalMonth(month));
      dispatch(updateExploreActionType('filter applied'));

      logExploreTrailCardListActionTaken({
        action_taken: 'sorted',
        sorting_action: 'seasonal'
      });
    },
    [dispatch]
  );

  return <SeasonalMonthSelector selectedMonth={selectedMonth} onMonthChange={handleSeasonalMonthChange} testId={testId} />;
};

export default ExploreSeasonalMonthSelector;
